import { getCustomerPricingExportList } from "@crescentParts/Services/CustomerPricingService";
import { CustomApiHandler } from "@crescentParts/Store/CustomHandlerCreator";
import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";

type HandlerType = CustomApiHandler<any>;

export const StartLoading: HandlerType = (props) => {
  props.dispatch({
    type: "Custom/LoadCustomerPricing",
  });
};

export const CustomerPricingGetExportedListCompleted: HandlerType = async (
  props,
) => {
  if (props.parameter) {
    try {
      const result: any = await getCustomerPricingExportList(
        props.parameter.aPiparameter,
      );
      // result may already be an object; only parse if it's a string
      let response: any;
      if (typeof result === "string") {
        try {
          response = JSON.parse(result);
        } catch {
          // If parsing fails, keep the raw string
          response = result;
        }
      } else {
        response = result;
      }

      if (response) {
        props.dispatch({
          type: "Custom/DispatchLoadCustomerPricing",
          exportList: response,
        });
      }
    } catch (error) {
      throw error;
    }
  }
};

export const chain = [StartLoading, CustomerPricingGetExportedListCompleted];

const getCustomerPricing = createHandlerChainRunner(
  chain,
  "getCustomerPricing",
);
export default getCustomerPricing;
